import { Fragment } from 'react';

import useGroupTravelTripMembers from './UseGroupTravelTripMembers';

import DefaultGroupMemberGrid from '../../components/grids/DefaultGroupMemberGrid';

import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';

import { SAVING_MSG } from '@usas/ui-web/utils/Constants';

const GroupTravelTripMembers = () => {
  const {
    isLoading,
    isSaving,
    gridData,
    modalState,
    onAddMemberToGroupClicked,
    onDeleteGroupMemberClicked,
    onDeleteModalConfirmClicked,
    onDeleteModalCancelClicked
  } = useGroupTravelTripMembers();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Travel Trip Group Members</Headings.H3>
        </div>
      </div>
      <div className="row">
        <div className='col-xs-12 usas-extra-top-margin'>
          <ActionIntraPageButton onClick={onAddMemberToGroupClicked}>Add Member to Group</ActionIntraPageButton>
        </div>
      </div>
      <div className='row'>
        <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
          <DefaultGroupMemberGrid
            data={gridData}
            isLoading={isLoading}
            onDeleteClicked={onDeleteGroupMemberClicked} />
        </div>
      </div>
      <PopUpModal
        widthPct={90}
        maxWidth={720}
        title={'Remove Group Member?'}
        displayPopUp={modalState.displayModal}
        onModalCanceled={onDeleteModalCancelClicked}>
        <div className="row">
          <div className="col-xs-12">
            <p><b>Member:</b> {modalState.firstName} {modalState.lastName}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="button" onClick={onDeleteModalConfirmClicked}>Remove</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onDeleteModalCancelClicked}>Cancel</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={SAVING_MSG}
        displayPopUp={isSaving} />
    </Fragment>
  );
};

export default GroupTravelTripMembers;